exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".address-card-add-link-position\n{\n    padding-right: 20px;\n    position: absolute;\n    right: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/details/addressinformation/address-information.component.css
// module id = 1948
// module chunks = 0